export default __webpack_public_path__ + "static/teal-debit-card-side-57322bd3cf13d61b08bca424f2a6961b.png";